import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { isPublic, useShareStore } from './shareStore';
import './ShareTitleBadge.css';

/** Count + public links as one string, so the badge re-renders only when that set changes. */
const selectPublic = (s) => {
  const list = Object.values(s.shares).filter(isPublic);
  const urls = list
    .map((sh) => sh.publicUrl || '')
    .filter(Boolean)
    .sort()
    .join(', ');
  return `${list.length}|${urls}`;
};

/**
 * Title bar badge while any dev server is public (Run & Share, Phase 2).
 * A click opens the Projects page, where the link card has "Stop sharing".
 */
export default function ShareTitleBadge({ onOpen }) {
  const { t } = useTranslation();
  const joined = useShareStore(selectPublic);
  const bar = joined.indexOf('|');
  const count = Number(joined.slice(0, bar)) || 0;
  const urls = joined.slice(bar + 1);
  if (count === 0) return null;
  const title = t('projects.run.share.badgeTitle', { count, urls });
  return (
    <button type="button" className="share-title-badge" data-testid="share-title-badge" onClick={onOpen} title={title} aria-label={title}>
      <span className="share-title-badge-dot" aria-hidden />
      <Globe size={12} aria-hidden />
      {t('projects.run.share.badge')}
      {count > 1 && <span className="share-title-badge-count">{count}</span>}
    </button>
  );
}
